import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import { Modal } from 'react-bootstrap';
import InputMask from 'react-input-mask';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class AircraftLogbookEngineSpecialCountersTab extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          overlay: {
            message: '',
            type: '',
            status: 'closed',
          },
          redirect_url: false,
          loaded: 0,
          aircraft_logbook_id: this.props.aircraft_logbook_id,
          special_counters: [],
          rawInputValue: '',
          rawInputValuePrevious: '',
        };
        this.edit = this.edit.bind(this);
      }

      handleChangeDecimal = (name, event) => {
        let rawInputValue = this.state.rawInputValue;
      
        let inputValue = event.target.value;
      
        // Se o input estiver vazio, limpa rawInputValue
        if (inputValue === '') {
          rawInputValue = '';
        } else if (/^\d+$/.test(inputValue)) {
          // Se for um número inteiro, atualiza rawInputValue
          rawInputValue = inputValue;
        } else {
          let newChar = inputValue.slice(-1);
      
          // Verifica se o novo caractere é um número, um ponto decimal ou uma vírgula
          if (!/^[0-9.,]$/.test(newChar)) {
            // Caractere inválido, não faz nada
            return;
          }
      
          // Substitui vírgula por ponto
          if (newChar === ',') {
            newChar = '.';
          }
      
          // Verifica se já existe um ponto decimal
          let hasDecimal = rawInputValue.includes('.');
      
          // Impede que "0" seja o primeiro dígito
          if (rawInputValue === '' && newChar === '0') {
            return;
          }
      
          // Determina se está adicionando ou removendo um caractere
          if (event.nativeEvent.inputType === 'deleteContentBackward') {
            // Removendo um caractere
            rawInputValue = rawInputValue.slice(0, -1);
          } else if (hasDecimal && newChar !== '.') {
            // Substitui o dígito após o ponto decimal
            let parts = rawInputValue.split('.');
            parts[1] = newChar;
            rawInputValue = parts.join('.');
          } else {
            // Adicionando um caractere
            rawInputValue += newChar;
          }
        }
            
        // Formata o valor para exibição com base em rawInputValue
        let formattedValue = this.formatInputValue(rawInputValue);
      
        // Atualiza o estado
        this.setState({
          [name]: formattedValue,
          rawInputValue: rawInputValue
        });
      };

      handleChangePreviousDecimal = (name, event) => {
        let rawInputValue = this.state.rawInputValuePrevious;
      
        let inputValue = event.target.value;
      
        // Se o input estiver vazio, limpa rawInputValue
        if (inputValue === '') {
          rawInputValue = '';
        } else if (/^\d+$/.test(inputValue)) {
          // Se for um número inteiro, atualiza rawInputValue
          rawInputValue = inputValue;
        } else {
          let newChar = inputValue.slice(-1);
      
          // Verifica se o novo caractere é um número, um ponto decimal ou uma vírgula
          if (!/^[0-9.,]$/.test(newChar)) {
            // Caractere inválido, não faz nada
            return;
          }
      
          // Substitui vírgula por ponto
          if (newChar === ',') {
            newChar = '.';
          }
      
          // Verifica se já existe um ponto decimal
          let hasDecimal = rawInputValue.includes('.');
      
          // Impede que "0" seja o primeiro dígito
          if (rawInputValue === '' && newChar === '0') {
            return;
          }
      
          // Determina se está adicionando ou removendo um caractere
          if (event.nativeEvent.inputType === 'deleteContentBackward') {
            // Removendo um caractere
            rawInputValue = rawInputValue.slice(0, -1);
          } else if (hasDecimal && newChar !== '.') {
            // Substitui o dígito após o ponto decimal
            let parts = rawInputValue.split('.');
            parts[1] = newChar;
            rawInputValue = parts.join('.');
          } else {
            // Adicionando um caractere
            rawInputValue += newChar;
          }
        }
            
        // Formata o valor para exibição com base em rawInputValue
        let formattedValue = this.formatInputValue(rawInputValue);
      
        // Atualiza o estado
        this.setState({
          [name]: formattedValue,
          rawInputValuePrevious: rawInputValue
        });
      };

      formatInputValue = (rawValue) => {
        if (!rawValue) {
          return '';
        }

        let [inteiro, decimal] = rawValue.split('.');

        // Ajusta a parte decimal para sempre ter um dígito
        decimal = decimal && decimal.length > 0 ? decimal[0] : '0';

        return `${inteiro}.${decimal}`;
      };


      // Handlers
      handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
      }
    
      handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = event.value;
        }
        this.setState(change);
      }

      // LM
      componentWillReceiveProps(newProps) {
        if(this.state.loaded === 0) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            loaded: 1,
          });
        }

        if(typeof newProps.special_counters['version'] !== 'undefined' && newProps.special_counters['version'] !== null && this.state.loaded === 1) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            special_counters: newProps.special_counters['version'],
          });
        }
      }
    
      // Fetch salvando a edição
      edit(event) {
        event.preventDefault();
        this.props.handleAlert('', '', 'open');
        var datasave = {
          id: this.state.edit_id,
          previous_logbook: this.state.previous_logbook,
          actual_logbook: this.state.actual_logbook,
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/aeronave/diario/contadores/especiais/voos', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
          }).catch((error) => {
            console.error(error);
          });
        });
      }

      showModalEdit (counter, event) {
        this.setState({ 
          edit_id: counter.id,
          previous_logbook: counter.previous_logbook_str,
          actual_logbook: counter.actual_logbook_str,
          rawInputValuePrevious: counter.previous_logbook_decimal,
          rawInputValue: counter.actual_logbook_decimal,
          field_type: counter.field_type,
          modal_edit: true,
        });
      }    
    
      render() {
        var self = this;
        return (
    <div>
      <RequestApi ref={'request_api'} />
      <h3 className="page-title pull-left">Engines Special Counters</h3>
      <div className="clearfix"></div>
      <hr/>
      <div className="table-responsive">
        <table className="table table-bordered table-hover table-striped">
          <thead>
            <tr>
              <th width="70px">Engine</th>
              <th width="150px">Counter</th>
              <th width="100px">Previous</th>
              <th width="100px">Actual</th>
              <th width="100px">Total</th>
              <th width="100px">Actions</th>
            </tr>
          </thead>
          <tbody>
          {self.state.special_counters.map(function(k)
          {
            var counter = k;
            return(
              <tr className="text-center" key={counter.id}>
                <td width="70px">{counter.engine_position}</td>
                <td width="150px">{counter.counter}</td>
                <td width="100px">{counter.previous_logbook_str}</td>
                <td width="100px">{counter.actual_logbook_str}</td>
                <td width="100px">{counter.total_str}</td>
                <td width="100px" className="text-center">
                    <button onClick={self.showModalEdit.bind(self, counter)} className="btn btn-primary btn-sm"><i className="fa fa-pencil"></i></button>                    
                </td>
              </tr>
            );
          })}
          </tbody>
        </table>
      </div>
      <Modal show={this.state.modal_edit} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
        <Modal.Header>
          <h4 className="pull-left">Engine Special Counter</h4>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_edit: false })}>
          <i className="fa fa-fw fa-close"></i></button>
          <div className="clearfix"></div>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={this.edit}>
            {this.state.field_type === 'decimal' ? 
              <div className="row">
                  <div className="col-md-6 form-group">
                    <label>Previous Logbook:</label>
                    <input className="form-control" value={this.state.previous_logbook} name="previous_logbook" onChange={this.handleChangePreviousDecimal.bind(this, 'previous_logbook')} placeholder="" />
                  </div>
                  <div className="col-md-6 form-group">
                    <label>Actual Logbook:</label>
                      <input value={this.state.actual_logbook} name="actual_logbook" className="form-control" onChange={this.handleChangeDecimal.bind(this, 'actual_logbook')} placeholder=""/>
                  </div>
              </div>
              : 
              <div className="row">
                  <div className="col-md-6 form-group">
                    <label>Previous Logbook:</label>
                    <InputMask required value={this.state.previous_logbook} name="previous_logbook" className="form-control" onChange={this.handleChange.bind(this, 'previous_logbook')} placeholder='' />
                  </div>
                  <div className="col-md-6 form-group">
                    <label>Actual Logbook:</label>
                    <InputMask required value={this.state.actual_logbook} name="actual_logbook" className="form-control" onChange={this.handleChange.bind(this, 'actual_logbook')} placeholder='' />
                  </div>
              </div>
            }
            <div>
                <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> Save</button>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_edit: false })}>
          <i className="fa fa-fw fa-close"></i></button>
        </Modal.Footer>
      </Modal>
    </div>
    );
  }
}

export default AircraftLogbookEngineSpecialCountersTab;


// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/Elements/AircraftLogbookEngineSpecialCountersTab.js